import {SET_USER} from '../../actionTypes';

export function set_user(user) {
	return {
		type: SET_USER,
		user
	};
}